import Utils from "../../Utils";
import GlobalDispatcher from "../../events/GlobalDispatcher";
import BaseDataProvider from "../../base/server/BaseDataProvider";

export default class SlotLocalData extends BaseDataProvider {
    constructor() {
        super();
        this.balance = 100;
        this.bet = 1;
        this.lines = 3;
        this.reels = [[1, 1, 1], [1, 1, 1], [1, 1, 1]];

        this.linesConfig = {
            1: [[0, 1], [1, 1], [2, 1]],
            2: [[0, 0], [1, 0], [2, 0]],
            3: [[0, 2], [1, 2], [2, 2]],
        };
        this.symbolsCoefs = {
            2: [0, 0, 1],
            3: [0, 0, 1],
            4: [0, 2, 3],
            5: [0, 2, 3],
            6: [0, 4, 5],
        };

        this.betPossibleConfig = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.linesPossibleConfig = [1, 2, 3];
    };


    action(data) {
        switch (data.action) {
            case 'init':
                this.calculateInit(data);
                break;
            case 'spin':
                this.calculateNewSpin(data);
                break;
        }
    }

    calculateInit(request) {
        let data = {};
        let reconnectData = localStorage.getItem('baseGame');
        if (reconnectData) {
            data = JSON.parse(reconnectData);
            data.action = 'reconnect';
            data.params = {
                betPossible: this.betPossibleConfig,
                linesPossible: this.linesPossibleConfig
            };
            this.balance = data.balance;
        } else {
            data.action = 'init';
            data.params = {
                betPossible: this.betPossibleConfig,
                linesPossible: this.linesPossibleConfig
            };
            data.current = {
                bet: 1,
                lines: 3
            };
            data.spin = {
                reels: this.createNewReels()
            };
            data.balance = this.balance;
        }
        setTimeout(() => {
            GlobalDispatcher.dispatch('dataProvider:hasResponse', data);
        }, 1000);
    }

    calculateNewSpin(request) {
        this.balance -= request.bet * request.lines;

        let data = {};
        data.action = 'spin';
        data.current = {};
        data.current.bet = request.bet;
        data.current.lines = request.lines;
        data.spin = {};
        data.spin.reels = this.createNewReels();
        data.balance = this.balance;

        localStorage.setItem('baseGame', JSON.stringify(data));

        setTimeout(() => {
            GlobalDispatcher.dispatch('dataProvider:hasResponse', data);
        }, 3000);
    }

    createNewReels() {
        let reels = [];
        for (let i = 0; i < 3; i++) {
            reels.push([]);
            for (let j = 0; j < 3; j++) {
                reels[i].push(Utils.getRandomInt(1, 6));
            }
        }
        return reels;
    }
}